/*
 * Copyright © 2017 - 2019 Atilika Inc. All rights reserved.
 */

import React, {memo, useCallback, useState} from "react";
import {createUseStyles} from "react-jss";
import UI from "../common/UI";
import {Helmet} from "react-helmet";

const useStyles = createUseStyles({
    viterbi: {
        marginTop: "2rem",
        "& p": {
            textAlign: "center",
            fontSize: ".875rem"
        },
        "& svg": {
            height: "auto",
            width: "100%"
        }
    },
    container: {
        cursor: "zoom-in"
    },
    zoomedViterbiContainer: {
        cursor: "zoom-out",
        background: UI.colors.black.alpha(0.9).toCSS(),
        height: "100%",
        left: 0,
        padding: "2rem",
        position: "fixed",
        top: 0,
        width: "100%",
        overflow: "auto"
    },
    zoomedViterbi: {
        "& svg": {
            width: "auto"
        }
    }
});

interface KuromojiDemoViterbiProps {
    graph?: string;
}

function KuromojiDemoViterbi({graph}: KuromojiDemoViterbiProps) {
    const classes = useStyles();
    const [enlarged, setEnlarged] = useState(false);

    const zoomIn = useCallback(() => setEnlarged(true), [setEnlarged]);
    const zoomOut = useCallback(() => setEnlarged(false), [setEnlarged]);

    if (!graph) {
        return null;
    }

    return (
        <div className={classes.viterbi}>
            <div
                className={classes.container}
                onClick={zoomIn}
                dangerouslySetInnerHTML={{__html: graph}}
            />
            <p>Click to enlarge.</p>
            {!enlarged ? null : (
                <div className={classes.zoomedViterbiContainer} onClick={zoomOut}>
                    <Helmet>
                        <body data-no-scroll />
                    </Helmet>
                    <div className={classes.zoomedViterbi}>
                        <div dangerouslySetInnerHTML={{__html: graph}} />
                    </div>
                </div>
            )}
        </div>
    );
}

export default memo(KuromojiDemoViterbi);
